module.exports = __webpack_public_path__ + "assets/images/circle_purple.svg?e2bc902fde3e1dbe8b4b8fdd4f070d2d";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/circle_purple.svg
// module id = 367
// module chunks = 0